let _OPTIONS = {
    "teamType": [
        {"label": "个人", "value": 1, "checked": 0, "disabled": true},
        {"label": "企业", "value": 2, "checked": 0, "disabled": false},
        {"label": "政务", "value": 3, "checked": 0, "disabled": false},
        {"label": "学校", "value": 4, "checked": 0, "disabled": false},
    ],
    "adminRole": [
        {"label": "系统", "value": 1, "checked": 0, "disabled": true},
        {"label": "团队负责人", "value": 2, "checked": 0, "disabled": false},
        {"label": "普通管理员", "value": 10, "checked": 0, "disabled": false},
    ],
    "employeeRole": [
        {"label": "任务处理部", "value": 3, "checked": 0, "disabled": false},
        // {"label": "接收任务", "value": 4, "checked": 0, "disabled": false},
        // {"label": "财务人员", "value": 3, "checked": 0, "disabled": false},
    ],
    "userRole": [
        {"label": "采购", "value": 1, "checked": 0, "disabled": true},
        {"label": "出纳", "value": 2, "checked": 0, "disabled": false},
        {"label": "员工", "value": 8, "checked": 0, "disabled": false},
        {"label": "商务会员", "value": 9, "checked": 0, "disabled": false},
    ],
    "adminLevel": [
        {"label": "ROOT", "value": 1, "checked": 0, "disabled": true},
        {"label": "系统管理员", "value": 2, "checked": 0, "disabled": true},
        {"label": "超级管理员", "value": 3, "checked": 0, "disabled": false},
        {"label": "高级管理员", "value": 4, "checked": 0, "disabled": false},
        {"label": "普通管理员", "value": 5, "checked": 1, "disabled": false},
    ],
    "userLevel": [
        {"label": "A级", "value": 1, "checked": 0, "disabled": false},
        {"label": "B级", "value": 2, "checked": 0, "disabled": false},
        {"label": "C级", "value": 3, "checked": 0, "disabled": false},
        {"label": "D级", "value": 4, "checked": 0, "disabled": false},
        {"label": "E级", "value": 5, "checked": 0, "disabled": false},
        {"label": "F级", "value": 6, "checked": 0, "disabled": false},
        {"label": "G级", "value": 7, "checked": 0, "disabled": false},
        {"label": "H级", "value": 8, "checked": 0, "disabled": false},
        {"label": "I级", "value": 9, "checked": 0, "disabled": false},
        {"label": "J级", "value": 10, "checked": 0, "disabled": false},
    ],
    "articleAttr": [
        {"label": "普通", "value": 1, "checked": 1},
        {"label": "推荐", "value": 2, "checked": 0},
        {"label": "置顶", "value": 3, "checked": 0},
        {"label": "头条", "value": 4, "checked": 0},
    ],
    "status": [
        {"label": "正常", "value": 1, "checked": 1},
        {"label": "回收", "value": 2, "checked": 0},
    ],
    "deviceStatus": [
        {"label": "未设置", "value": 0, "checked": 0},
        {"label": "遗失", "value": 1, "checked": 0},
        {"label": "报废", "value": 2, "checked": 0},
        {"label": "使用", "value": 3, "checked": 0},
        {"label": "维修", "value": 4, "checked": 0},
        {"label": "校准中", "value": 5, "checked": 0},
        {"label": "外借", "value": 6, "checked": 0}
    ],
    "period":[
        { "label": "未设置", "value": 0, "checked": 0, "disabled": false},
        { "label": "半年", "value": 1, "checked": 0, "disabled": false},
        { "label": "1年", "value": 2, "checked": 0, "disabled": false},
        { "label": "2年", "value": 3, "checked": 0, "disabled": false},
        { "label": "3年", "value": 4, "checked": 0, "disabled": false},
        { "label": "NA", "value": 30, "checked": 0, "disabled": false}
    ],
    "reminder1":[
        { "label": "未设置", "value": 0, "checked": 0, "disabled": false},
        { "label": "内校", "value": 1, "checked": 0, "disabled": false},
        { "label": "外校", "value": 2, "checked": 0, "disabled": false},
        { "label": "厂校", "value": 3, "checked": 0, "disabled": false},
        { "label": "免校", "value": 4, "checked": 0, "disabled": false},
    ],
    "deviceLevel":[
        { "label": "未设置", "value": 0, "checked": 0, "disabled": false},
        { "label": "A", "value": 1, "checked": 0, "disabled": false},
        { "label": "B", "value": 2, "checked": 0, "disabled": false},
        { "label": "C", "value": 3, "checked": 0, "disabled": false},
        { "label": "D", "value": 4, "checked": 0, "disabled": false},
        { "label": "E", "value": 5, "checked": 0, "disabled": false},
    ],
    "taskType":[
        { "label": "当月", "value": 1, "checked": 0, "disabled": false},
        { "label": "下月", "value": 2, "checked": 0, "disabled": false},
        { "label": "当年", "value": 3, "checked": 0, "disabled": false},

    ],
    "deviceType":[
        { "label": "检具清单", "value": 1, "checked": 0, "disabled": false},
        { "label": "压力表&压力容器&安全阀清单", "value": 2, "checked": 0, "disabled": false},
        { "label": "扭力扳手&气动扳手清单", "value": 3, "checked": 0, "disabled": false},
        { "label": "常规量具清单", "value": 4, "checked": 0, "disabled": false},

    ],
    "taskStatus":[
        { "label": "未开始", "value": 0, "checked": 0, "disabled": false},
        { "label": "已开始", "value": 1, "checked": 0, "disabled": false},
        { "label": "已完成", "value": 2, "checked": 0, "disabled": false},

    ],
    "emailType":[
        { "label": "定时发邮件", "value": 1, "checked": 0, "disabled": false},
        { "label": "异常上报发邮件", "value": 2, "checked": 0, "disabled": false},

    ],
    "taskOperatStatus":[
        { "label": "未处理", "value": 0, "checked": 0, "disabled": false},
        { "label": "已处理", "value": 1, "checked": 0, "disabled": false},

    ],

};

export {
    _OPTIONS
}